import { PropsWithChildren } from "react";

const styles = new Proxy({"Section":"Section-fd5e0","SectionTitle":"SectionTitle-fd5e0"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

export type SectionProps = PropsWithChildren<{
  id?: string;
  title?: string;
  className?: string;
  maxWidth?: number;
  style?: React.CSSProperties;
}>;

const Section = ({
  id,
  title,
  className,
  maxWidth,
  style,
  children,
}: SectionProps) => (
  <section
    id={id}
    className={[className, styles.Section].filter(Boolean).join(" ")}
    style={style}
  >
    <div className="container mx-auto" style={{ maxWidth }}>
      {title && (
        <h2 className={`mb-4 mx-auto ${styles.SectionTitle}`}>
          {title.split("|").map((rows, i) => (
            <span key={i}>
              {rows}
              <br />
            </span>
          ))}
        </h2>
      )}
      {children}
    </div>
  </section>
);

export default Section;
